import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyD3gF1cCZ6gbn2paxrmTuQrSz_cG14gtIQ",
  authDomain: "kalam-kids.firebaseapp.com",
  projectId: "kalam-kids",
  storageBucket: "kalam-kids.firebasestorage.app",
  messagingSenderId: "994148417074",
  appId: "1:994148417074:web:b2d4e40bb426da663cc62b",
  measurementId: "G-8L3KLRVM2P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore 
const db = getFirestore(app);

// Initialize Auth
const auth = getAuth(app);

// Set persistence for Auth
setPersistence(auth, browserLocalPersistence)
  .then(() => {
    // Persistence is set, now the session should remain intact
  })
  .catch((error) => {
    console.error("Error setting persistence: ", error);
  });

export { db, auth };